import { useAppSelector } from '../hooks/useAppSelector';
import * as referenceSlice from '../data/reference.slice';

export const useMessagingMethod = (typeId: number | undefined): string => {
  const types = useAppSelector(referenceSlice.selectMessagingMethods);
  const type = types.find((t) => t.messagingMethodID === typeId);
  return type ? type.messagingMethodName : types[0]?.messagingMethodName || '';
};
